import * as React from 'react';

import { AddQuestionForm } from '../../components/AddPostForm';
import { BreadCrumbsContainer } from '../BreadCrumbs';
import { AddPostFormStub } from '../../components/AddPostFormStubs';
import { canSeeFormX } from './utils';

/**
 * Контейнер формы добавления/редактирования вопроса
 */
export const AddQuestionFormContainer = () => {
  if (!canSeeFormX()) {
    return <AddPostFormStub />;
  }

  return (
    <>
      <BreadCrumbsContainer />
      <AddQuestionForm title={'Задать вопрос'} />
    </>
  );
};
